import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';

export const PartnerActivityReport = async (period) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/PartnerActivityReport?period=${period}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}